var productKeys = {
  confluence: {
    mediaInline: ''
  },
  jira: {
    // Manged by Linking Platform. No Rollout plan found for Jira
    mediaInline: ''
  }
};
export var getProductKeys = function getProductKeys() {
  return productKeys;
};